/* eslint-disable react/prop-types */
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, { useState, useEffect } from "react"
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, FormGroup, Modal } from "reactstrap";
import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { useSelector, useDispatch } from "react-redux";
import { useHistory, withRouter, Link } from "react-router-dom";
import { getOTPUrl, verifyOTPUrl, getCheckCustomerExistsUrl } from "../../helpers/fakebackend_helper";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import banner from "../../assets/images/banner/banner.jpg";
import authHeader from "helpers/authHeader";
import BranchLogin from "./BranchLogin";

//Verification code package
import AuthCode from "react-auth-code-input"
const Login = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isLoading, setLoading] = useState(false);

    // Is this a LAN environment?
    const isLANEnv = window.location.hostname.includes(process.env.REACT_APP_LAN_URL);

    // State to set the login form page or action based on the environment
    const [loginStepsForLan, setLoginStepsForLan] = useState({
        normalLogin: true,
        branchLogin: false,
    })
    // State to set login response or auth details
    const [persistAuthDetailsForLan, setPersistAuthDetailsForLan] = useState(null);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            mobilenumber: '',
            email: '',
            one: '',
            two: '',
            three: '',
            four: ''
        },
        validationSchema: Yup.object({
            mobilenumber: Yup.string().required("Mobile Number required"),
            email: Yup.string().email("Must be a valid Email").max(50),
        }),
        onSubmit: (values) => {
            // dispatch(loginUser(values, props.history));
        }

    });

    const { error } = useSelector(state => ({
        error: state.Login.error,
    }));

    function chkNumeric(e) {
        debugger;
        let input = e.target.value;
        if (input == "") {
            validation.handleChange(e);
        }
        else if (typeof input !== "undefined") {
            var pattern = new RegExp(/^[0-9\b]+$/);

            if (pattern.test(input)) {
                validation.handleChange(e);
                if (e.target.id == "1") {
                    $('#2').val('')
                    $('#2').focus();
                }
                else if (e.target.id == "2") {
                    $('#3').val('')
                    $('#3').focus();
                }
                else if (e.target.id == "3") {
                    $('#4').val('')
                    $('#4').focus();
                }
                else if (e.target.id == "4") {
                    $('#verify').focus();
                }
            }
        }
    }

    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,

            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    const textboxRounded = {
        color: "black",
        //fontSize: "larger"
    };

    const modalpopup = {
        border: "2px solid black", textAlign: "center", fontSize: "large", color: "black"
    };

    const cardBackground = {
        borderRadius: 15,
        flex: 1,
        marginTop: "20px",
        boxShadow: "#504f4f6b 5px 5px 20px",
        width: "99%"
    }

    const [modal_backdrop, setmodal_backdrop] = useState(false);
    const [guid, setguid] = useState("");

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    };

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    };

    function GetOTP() {
        debugger;
        if (((validation.touched.mobilenumber && validation.errors.mobilenumber == "") || (validation.touched.mobilenumber && validation.errors.mobilenumber == undefined)) &&
            (validation.errors.email == "") || (validation.errors.email == undefined)) {
            if (validation.values.mobilenumber.toString().length != 10) {
                ErrorMessage("Please enter 10 digit Mobile number!");
                $('#txtMobileNo').focus();
            }
            else {
                const guidGenerated = uuid();

                const otpModel = {
                  Guid: guidGenerated,
                  MobileNo: $('#txtMobileNo').val(),
                  Email: $('#txtEmail').val(),
                  loginViaLAN: isLANEnv
                };

                setLoading(true);

                axios.post(getOTPUrl(), otpModel, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    if (res.data.responseCode == "OK") {
                        setLoading(false);
                        setguid(guidGenerated);
                        tog_backdrop();
                        SuccessMessage("OTP is sent on your Mobile Number!")
                    }
                })

                //axios.post(getOTPUrl(), otpModel).then(res => {
                //    if (res.data.responseCode == "OK") {
                //        setLoading(false);
                //        setguid(guidGenerated);
                //        tog_backdrop();
                //        SuccessMessage("OTP is sent on your Mobile Number!")
                //    }
                //})
            }
        }
    }

    function ResendOTP() {
        if ((validation.touched.mobilenumber && validation.errors.mobilenumber == "") || (validation.touched.mobilenumber && validation.errors.mobilenumber == undefined)) {
            if (validation.values.mobilenumber.toString().length != 10) {
                ErrorMessage("Please enter 10 digit Mobile number!");
            }
            else {
                const guidGenerated = uuid();

                const otpModel = {
                    Guid: guidGenerated,
                    MobileNo: $('#txtMobileNo').val(),
                    Email: $('#txtEmail').val(),
                    loginViaLAN: isLANEnv
                };

                axios.post(getOTPUrl(), otpModel)
                    .then(res => {
                        if (res.data.responseCode == "OK") {
                            setguid(guidGenerated);
                            tog_backdrop();
                            SuccessMessage("OTP is sent on your Mobile Number!")
                            setmodal_backdrop(true);
                        }
                    })
            }
        }
    }

    function CheckCustomerExists() {
        debugger;
        const allCustomerAccountModel = {
            MobileNo: !isLANEnv ? $('#txtMobileNo').val() : persistAuthDetailsForLan?.mobileNo,
        };

        axios.post(getCheckCustomerExistsUrl(), allCustomerAccountModel, { headers: authHeader() })
            .then(response => {
                if (response.data == true) {
                    history.push('/Status');
                }
                else if (response.data == false) {
                    history.push('/CreateNewAccount');
                }
            }, (error) => {
                console.log(error.response);
            })
    }

    // Function to set the authentication details
    function setAuthDetails(Data) {
        if (Data) {
            localStorage.setItem('authCustomer', JSON.stringify(Data));
            CheckCustomerExists();
        } else {
            ErrorMessage("Authentication details are not available.");
        }
    }

    function VerifyOTP() {

        if (result == null) {
            ErrorMessage("Please enter OTP!");
            return;
        }

        if (result.length != 4) {
            ErrorMessage("Please enter OTP!");
            return;
        }
        const enteredOTP = result;
        const otpModel = {
            Guid: guid,
            MobileNo: $('#txtMobileNo').val(),
            Email: $('#txtEmail').val(),
            OTP: enteredOTP
        };

        axios.post(verifyOTPUrl(), otpModel)
            .then(res => {
                if (res.data.returnSuccess == true) {
                    if (isLANEnv) {
                        console.log("LAN environment detected, redirecting to BranchLogin");
                        setPersistAuthDetailsForLan(res.data);
                        setLoginStepsForLan({ normalLogin: false, branchLogin: true });
                    } else {
                        setAuthDetails(res.data);
                    }
                }
                else if (res.data.returnSuccess == false) {
                    ErrorMessage(res.data.returnMessage);
                }
            })
    }

    const [result, setResult] = useState();
    const handleOnChange = (res) => {
        debugger;
        setResult(res);
        if (res.length == 4) {
            $('#verify').focus();
        }
    };

    const userLoginFormProps = {
        cardBackground,
        textboxRounded,
        validation,
        error,
        chkNumeric,
        GetOTP,
        ResendOTP,
        VerifyOTP,
        modal_backdrop,
        tog_backdrop,
        handleOnChange
    }

    if (!isLANEnv) {
        return (
          <UserLoginForm {...userLoginFormProps} />   
        )
    } else if (isLANEnv && loginStepsForLan.normalLogin) {
        return (
            <UserLoginForm {...userLoginFormProps} />
        );
    } else if (isLANEnv && loginStepsForLan.branchLogin) {
        return (
            <BranchLogin
                isLANEnv={isLANEnv} 
                persistAuthDetailsForLan={persistAuthDetailsForLan}
                setAuthDetails={(data) => setAuthDetails(data)}
            />
        );
    }
};

const UserLoginForm = ({
  cardBackground,
  textboxRounded,
  validation,
  error,
  chkNumeric,
  GetOTP,
  ResendOTP,
  VerifyOTP,
  modal_backdrop,
  tog_backdrop,
  handleOnChange,
}) => {
  return (
    <React.Fragment>
      <MetaTags>
        <title>JSB-Login</title>
      </MetaTags>

      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden" style={cardBackground}>
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={12}>
                      <img
                        src={banner}
                        alt=""
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div style={{ textAlign: "center" }}>
                    <label
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "x-large",
                      }}
                    >
                      Let&#8217;s get started!
                    </label>
                    <br />
                    <label style={{ color: "black", fontSize: "smaller" }}>
                      To get an instant Account
                    </label>
                  </div>
                  <br />
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation?.handleSubmit()
                        return false
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}
                      <div className="mb-3">
                        <FormGroup className="mb-3">
                          <Label
                            className="form-label"
                            style={{ color: "black" }}
                          >
                            Mobile Number
                          </Label>
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            *
                          </span>
                          <Input
                            autoFocus
                            id="txtMobileNo"
                            maxLength="10"
                            name="mobilenumber"
                            value={validation?.values?.mobilenumber || ""}
                            type="text"
                            min="1"
                            placeholder="Mobile Number"
                            className="form-control"
                            style={textboxRounded}
                            onChange={e => {
                              chkNumeric(e)
                            }}
                            onBlur={validation?.handleBlur}
                            invalid={
                              validation?.touched?.mobilenumber &&
                              validation?.errors?.mobilenumber
                                ? true
                                : false
                            }
                            autoComplete="off"
                          />
                          {validation?.touched?.mobilenumber &&
                          validation?.errors?.mobilenumber ? (
                            <FormFeedback type="invalid">
                              {validation?.errors?.mobilenumber}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </div>

                      <div className="mb-3">
                        <FormGroup className="mb-3">
                          <Label
                            className="form-label"
                            style={{ color: "black" }}
                          >
                            Email
                          </Label>
                          <Input
                            id="txtEmail"
                            maxLength="50"
                            name="email"
                            value={validation?.values?.email || ""}
                            type="email"
                            placeholder="Email"
                            className="form-control"
                            style={textboxRounded}
                            onChange={validation?.handleChange}
                            onBlur={validation?.handleBlur}
                            invalid={
                              validation?.touched?.email &&
                              validation?.errors?.email
                                ? true
                                : false
                            }
                            autocomplete="off"
                          />
                          {validation?.touched?.email &&
                          validation?.errors?.email ? (
                            <FormFeedback type="invalid">
                              {validation?.errors?.email}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </div>
                      <br></br>
                      <div>
                        <label style={{ color: "red" }}>
                          {" "}
                          PLEASE KEEP YOUR COPY OF PROOF OF IDENTITY (POI) &
                          PROOF OF ADDRESS (POA) READY WITH YOU TO UPLOAD
                        </label>
                      </div>
                      <div className="mt-3 d-grid">
                        <button
                          style={{
                            backgroundColor: "#9a084f",
                            fontSize: "larger",
                            borderRadius: "0.75rem",
                          }}
                          className="btn btn-primary btn-block"
                          type="submit"
                          onClick={() => {
                            GetOTP()
                          }}
                          data-toggle="modal"
                        >
                          Get OTP
                        </button>
                        <Modal
                          autoFocus={false}
                          isOpen={modal_backdrop}
                          toggle={() => {
                            tog_backdrop()
                          }}
                          backdrop={"static"}
                          id="staticBackdrop"
                          className="modal-dialog modal-dialog-centered"
                        >
                          <div
                            className="modal-body"
                            style={{ textAlign: "center" }}
                          >
                            <h5
                              className="modal-title"
                              id="staticBackdropLabel"
                              style={{ color: "black" }}
                            >
                              Enter OTP sent on your mobile number
                            </h5>
                            <br />
                            <br />
                            <Row>
                              <Col xs={12}>
                                <FormGroup className="verification">
                                  <label
                                    htmlFor="digit1-input"
                                    className="sr-only"
                                  >
                                    Dight 1
                                  </label>
                                  <AuthCode
                                    characters={4}
                                    className="form-control form-control-lg text-center"
                                    allowedCharacters="^[0-9]"
                                    password={true}
                                    inputStyle={{
                                      width: "76px",
                                      height: "42px",
                                      padding: "8px",
                                      borderRadius: "8px",
                                      fontSize: "16px",
                                      textAlign: "center",
                                      marginRight: "15px",
                                      border: "1px solid #ced4da",
                                      textTransform: "uppercase",
                                    }}
                                    onChange={handleOnChange}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            <Row>
                              <Col lg="12">
                                <Label>Don&#8217;t receive the OTP?</Label>
                                <a
                                  style={{
                                    marginLeft: "10px",
                                    color: "red",
                                    fontSize: "larger",
                                  }}
                                  onClick={() => {
                                    ResendOTP()
                                  }}
                                  data-toggle="modal"
                                >
                                  Resend OTP
                                </a>
                              </Col>
                            </Row>
                          </div>
                          <div>
                            <div className="modal-footer">
                              <button
                                className="btn btn-primary btn-block"
                                style={{
                                  backgroundColor: "#9a084f",
                                  width: "100px",
                                  borderRadius: "0.75rem",
                                  fontSize: "15px",
                                }}
                                type="submit"
                                id="verify"
                                onClick={() => {
                                  VerifyOTP()
                                }}
                              >
                                Verify
                              </button>
                            </div>
                          </div>
                        </Modal>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <footer
              className="sm-12"
              style={{
                backgroundColor: "#333333",
                color: "white",
                height: "40px",
                position: "absolute",
                bottom: "0",
              }}
            >
              <Container fluid={true}>
                <Row>
                  <Col style={{ marginTop: "15px" }} md={6}>
                    {" "}
                    &copy; {new Date().getFullYear()} all rights reserved
                  </Col>
                  <Col style={{ marginTop: "15px" }} md={6}>
                    <div className="text-sm-end d-none d-sm-block">
                      Powered by ZingWorks LLP
                    </div>
                  </Col>
                </Row>
              </Container>
            </footer>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login);

Login.propTypes = {
    history: PropTypes.object,
    cardBackground: PropTypes.object, // or PropTypes.object, etc.
    textboxRounded: PropTypes.object,
    validation: PropTypes.func,
    error: PropTypes.string,
    chkNumeric: PropTypes.func,
    GetOTP: PropTypes.func,
    ResendOTP: PropTypes.func,
    VerifyOTP: PropTypes.func,
    modal_backdrop: PropTypes.bool,
    tog_backdrop: PropTypes.func,
    handleOnChange: PropTypes.func,
};

